import { IS_SSR } from '@constants/ssr';

import { SessionContextType } from '../types';
import { getLocalAuthenticationToken, hasLocalTokens } from './token';

export const getSessionStatus = (): SessionContextType => {
  if (IS_SSR) {
    return [false, null];
  }

  const hasTokens = hasLocalTokens();

  if (hasTokens) {
    const token = getLocalAuthenticationToken();

    return [true, token ?? ''];
  }

  return [false, null];
};
